<template>
  <div class="home">
    <caxton-home></caxton-home>
  </div>
</template>

<script>
// @ is an alias to /src
import CaxtonHome from "@/components/CaxtonHome";

export default {
  name: "Home",
  components: {
    CaxtonHome
  }
};
</script>
